// Pratinjau lokal deterministik untuk bacaan Lembar. Bukan model produksi.
const MARKS = {
  id: ["tapi", "namun", "atau", "belum", "tidak", "ragu", "bingung", "harus", "mungkin", "sebaiknya", "khawatir", "takut", "?"],
  en: ["but", "however", " or ", "not yet", "unsure", "should", "maybe", "worried", "afraid", "unclear", "?"],
};

const STOP = {
  id: new Set(["untuk", "dengan", "karena", "tetapi", "adalah", "dalam", "tidak", "sudah", "belum", "akan", "yang", "saya", "kalau", "masih", "harus", "sangat", "lebih", "bisa", "atau", "juga", "kemudian", "setelah", "sebelum"]),
  en: new Set(["about", "because", "there", "their", "which", "would", "should", "could", "still", "after", "before", "where", "while", "being", "other", "these", "those", "going", "really", "always"]),
};

const T = {
  id: {
    abstain: "Catatan ini belum cukup untuk dibaca sebagai keputusan.",
    pattern: (w, n) => `Kata "${w}" muncul ${n} kali di catatan ini.`,
    tension: (c) => `Catatan menyebut "${c}" tanpa arah yang dipilih.`,
    gapMeasure: "Tidak ada ukuran atau tenggat yang disebut di catatan ini.",
    gapOption: "Tidak ada pilihan pembanding yang disebut di catatan ini.",
    summary: (topic, n) => `Catatan ini berpusat pada ${topic}. Ada ${n} catatan tersimpan, dan arahnya belum dipilih.`,
    q1: (topic) => `Apa yang harus diputuskan lebih dulu tentang ${topic}?`,
    q2: "Ukuran apa yang membuat hal ini dianggap sudah selesai?",
    q3: "Pilihan apa saja yang sebenarnya tersedia saat ini?",
    topic: "catatan yang belum jadi keputusan",
  },
  en: {
    abstain: "This note is not yet enough to read as a decision.",
    pattern: (w, n) => `The word "${w}" appears ${n} times in this sheet.`,
    tension: (c) => `The note mentions "${c}" without a chosen direction.`,
    gapMeasure: "No measure or deadline is named in this sheet.",
    gapOption: "No comparable option is named in this sheet.",
    summary: (topic, n) => `This sheet centres on ${topic}. ${n} notes are saved, and no direction is chosen yet.`,
    q1: (topic) => `What has to be decided first about ${topic}?`,
    q2: "What measure would make this count as finished?",
    q3: "Which options are actually available right now?",
    topic: "a note that is not a decision yet",
  },
};

const cut = (s, n) => {
  const v = s.trim();
  if (v.length <= n) return v;
  return v.slice(0, n).replace(/\s+\S*$/, "");
};

const sentences = (text) =>
  text
    .split(/[.\n;!?]+/)
    .map((s) => s.trim())
    .filter((s) => s.length >= 8);

function repeated(text, lang) {
  const counts = new Map();
  (text.toLowerCase().match(/[\p{L}']{5,}/gu) ?? []).forEach((w) => {
    if (STOP[lang].has(w)) return;
    counts.set(w, (counts.get(w) ?? 0) + 1);
  });
  let best = null;
  counts.forEach((n, word) => {
    if (n >= 2 && (!best || n > best.n)) best = { word, n };
  });
  return best;
}

export function buildReading(userTexts, lang, title) {
  const t = T[lang] ?? T.id;
  const all = userTexts.join(" ");
  const lower = all.toLowerCase();
  const hit = MARKS[lang === "en" ? "en" : "id"].some((m) => lower.includes(m));

  if (all.trim().length < 120 || !hit) {
    return { abstained: true, summary: t.abstain, signals: [], questions: [] };
  }

  const topic = cut(title?.trim() || sentences(all)[0] || "", 60) || t.topic;
  const signals = [];
  const rep = repeated(all, lang === "en" ? "en" : "id");
  if (rep) signals.push({ text: cut(t.pattern(rep.word, rep.n), 180), kind: "pattern" });
  const clause = sentences(all).find((s) => MARKS[lang === "en" ? "en" : "id"].some((m) => s.toLowerCase().includes(m.trim())));
  if (clause) signals.push({ text: cut(t.tension(cut(clause, 100)), 180), kind: "tension" });
  if (!/\d/.test(all)) signals.push({ text: t.gapMeasure, kind: "gap" });
  else if (!/\b(atau|or)\b/i.test(all)) signals.push({ text: t.gapOption, kind: "gap" });
  if (signals.length === 0) signals.push({ text: t.gapOption, kind: "gap" });

  return {
    abstained: false,
    summary: cut(t.summary(topic, userTexts.length), 500),
    signals: signals.slice(0, 4),
    questions: [t.q1(topic), t.q2, t.q3].map((text, i) => ({ id: `q${i + 1}`, text: cut(text, 200) })),
  };
}
